import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['cardLaunchLink', 'launchDialog', 'lessonCard']
  static values = { externalAppUrl: String }

  connect() {
    if (this.hasCardLaunchLinkTarget) {
      const courseLink = $(this.cardLaunchLinkTarget).attr('href')
      courseLink && this.updateLessonCard(courseLink)
    }
  }

  updateLessonCard = (courseLink) => {
    $(this.lessonCardTarget).css('cursor', 'pointer')
    courseLink &&
      $(this.lessonCardTarget).on('click', (event) => {
        if ($(event.target).closest('.resources-container').length) return

        if (this.hasExternalAppUrlValue) {
          event.preventDefault()
          this.launchDialogTarget.showModal()
          return
        }

        window.location = courseLink
      })
  }

  launchExternalApp = (event) => {
    event.preventDefault()
    event.stopPropagation()
    window.location = this.externalAppUrlValue
  }

  launchLesson = (event) => {
    event.preventDefault()
    event.stopPropagation()
    window.location = $(this.cardLaunchLinkTarget).attr('href')
  }
}
